export const FIXED_PAGES = ["attendance", "tasks", "reports", "profile"];
export const DYNAMIC_PAGES = ["sales", "manufacture", "rto"];

const fixedPageSet = new Set(FIXED_PAGES);
const dynamicPageSet = new Set(DYNAMIC_PAGES);

const FIXED_ROUTE_PREFIXES = [
  "/attendance",
  "/attendance-history",
  "/tasks",
  "/tasks/history",
  "/task-history",
  "/reports",
  "/profile",
];

const DYNAMIC_ROUTE_PERMISSIONS = [
  { prefix: "/sales", permissionId: "sales" },
  { prefix: "/manufacture", permissionId: "manufacture" },
  { prefix: "/rto", permissionId: "rto" },
];

const normalizePathname = (pathname) => {
  const value = String(pathname || "").trim();

  if (!value || value === "/") {
    return "/";
  }

  return value.endsWith("/") ? value.slice(0, -1) : value;
};

const matchesRoutePrefix = (pathname, prefix) => {
  const normalizedPath = normalizePathname(pathname);
  const normalizedPrefix = normalizePathname(prefix);

  return (
    normalizedPath === normalizedPrefix ||
    normalizedPath.startsWith(`${normalizedPrefix}/`)
  );
};

export const isFixedPage = (pageId) => fixedPageSet.has(String(pageId || ""));

export const isDynamicPage = (pageId) => dynamicPageSet.has(String(pageId || ""));

export const hasAccess = (pageId, permissions = []) => {
  if (isFixedPage(pageId)) {
    return true;
  }

  return permissions.includes(pageId);
};

export const isFixedPath = (pathname) =>
  FIXED_ROUTE_PREFIXES.some((prefix) => matchesRoutePrefix(pathname, prefix));

export const getDynamicPermissionForPath = (pathname) => {
  const match = DYNAMIC_ROUTE_PERMISSIONS.find(({ prefix }) =>
    matchesRoutePrefix(pathname, prefix)
  );

  return match?.permissionId || null;
};
